import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";

import {InquiryButtonTypeName} from "../../../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../../../application/utils/ApplicationSource";
import {GTMEventApplicationSourceSection} from "../../../../lead/types/GTMEvenApplicationSourceSection";
import {getOfferDisplayStatus} from "../../../../offer/utils/get_offer_display_status";
import {IGTMEventLeadForm} from "../../../../tracking/google_tag_manager/gtm_event_form_open";
import {useReelInquiryFormData} from "../../../hooks/use_reel_inquiry_form_data";
import {IReelDetails} from "../../../types/IReelDetails";

interface IProps {
    reel: IReelDetails;
    onInquiryFormModalOpen?(): void;
    onInquiryFormModalClose?(): void;
}

export const ReelDetailsInquiryFormButton = (props: IProps) => {
    const source = ApplicationSource.VideoReel;
    const applicationSourceSectionData = ApplicationSourceSection.VIDEO_REEL;

    const {vendor, offer, isLoading} = useReelInquiryFormData(props.reel.action_button_offer, props.reel.action_button_property);
    const isSaleOverLimit = Boolean(offer && getOfferDisplayStatus(offer) === "limited");
    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.VENDOR,
        source: GTMEventApplicationSourceSection.LISTING_REELS,
        vendorName: (vendor?.name || vendor?.id.toString()) ?? "",
        offerName: (offer?.name || offer?.id.toString()) ?? ""
    };

    if (isLoading) {
        return <Button variant="filled_primary" size="x-small" css={w100} isLoading disabled />;
    }

    return vendor && offer ? (
        <ApplicationModalButton
            source={source}
            onOpen={props.onInquiryFormModalOpen}
            onClose={props.onInquiryFormModalClose}
            render={({openModal}) => {
                return (
                    <Button type="button" variant="filled_primary" size="x-small" css={[w100]} onClick={() => openModal(gtmData)}>
                        Zapytaj dewelopera
                    </Button>
                );
            }}
            sourceSection={applicationSourceSectionData}
            vendorId={vendor?.id}
            offerId={offer?.id}
            propertyId={null}
            forceClose={isSaleOverLimit}
        />
    ) : null;
};
import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";

import {InquiryButtonTypeName} from "../../../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../../../application/utils/ApplicationSource";
import {GTMEventApplicationSourceSection} from "../../../../lead/types/GTMEvenApplicationSourceSection";
import {getOfferDisplayStatus} from "../../../../offer/utils/get_offer_display_status";
import {IGTMEventLeadForm} from "../../../../tracking/google_tag_manager/gtm_event_form_open";
import {useReelInquiryFormData} from "../../../hooks/use_reel_inquiry_form_data";
import {IReelDetails} from "../../../types/IReelDetails";

interface IProps {
    reel: IReelDetails;
    onInquiryFormModalOpen?(): void;
    onInquiryFormModalClose?(): void;
}

export const ReelDetailsInquiryFormButton = (props: IProps) => {
    const source = ApplicationSource.VideoReel;
    const applicationSourceSectionData = ApplicationSourceSection.VIDEO_REEL;

    const {vendor, offer, isLoading} = useReelInquiryFormData(props.reel.action_button_offer, props.reel.action_button_property);
    const isSaleOverLimit = Boolean(offer && getOfferDisplayStatus(offer) === "limited");
    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.VENDOR,
        source: GTMEventApplicationSourceSection.LISTING_REELS,
        vendorName: (vendor?.name || vendor?.id.toString()) ?? "",
        offerName: (offer?.name || offer?.id.toString()) ?? ""
    };

    if (isLoading) {
        return <Button variant="filled_primary" size="x-small" css={w100} isLoading disabled />;
    }

    return vendor && offer ? (
        <ApplicationModalButton
            source={source}
            onOpen={props.onInquiryFormModalOpen}
            onClose={props.onInquiryFormModalClose}
            render={({openModal}) => {
                return (
                    <Button type="button" variant="filled_primary" size="x-small" css={[w100]} onClick={() => openModal(gtmData)}>
                        Zapytaj dewelopera
                    </Button>
                );
            }}
            sourceSection={applicationSourceSectionData}
            vendorId={vendor?.id}
            offerId={offer?.id}
            propertyId={null}
            forceClose={isSaleOverLimit}
        />
    ) : null;
};
